module.exports = __webpack_public_path__ + "static/media/ac_unknown.png";